import { Card, Row, Tooltip, Button } from "antd";
import { gsap } from "gsap";
import Dot from "../../../Components/Dot";
import NivoPieChart from "../../../charts/nivo/NivoPieChart";
import React, { useMemo, useRef } from "react";
import ColoredTag from "../../../Components/ColoredTag";


const calculateTotalDelta = (currentData, previousData) => {
    if (!previousData) return null;
    const currentTotal = Object.values(currentData).reduce((sum, value) => typeof value === 'number' ? sum + value : sum, 0);
    const previousTotal = Object.values(previousData).reduce((sum, value) => typeof value === 'number' ? sum + value : sum, 0);
    return currentTotal - previousTotal;
};

const formatter = (data) => {
    return Object.entries(data).filter(([key]) => key !== 'totalDelta').map(([key, value]) => ({
        id: key, label: key, value
    }));
};

const stripDayFromData = (stringDate) => {
    const date = new Date(stringDate);
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    const year = date.getFullYear();
    return `${month} ${year}`;
};

const PieGrid = ({ chartData, colorMapping, fieldNames, rows = 12, showDelta = false }) => {
    const formattedChartData = useMemo(() => chartData.map((data, index) => ({
        ...data,
        totalDelta: showDelta ? Math.abs(calculateTotalDelta(data, chartData[index - 1])) : null
    })), [chartData, showDelta]);
    console.log(chartData, colorMapping, fieldNames)

    const refs = useRef([]);

    const triggerAnimation = () => {
        formattedChartData.forEach((_, index) => {
            const direction = index % 2 === 0 ? -1 : 1; // Alternate direction for animation
            gsap.fromTo(refs.current[index], {
                x: direction * 300, // Start off-screen left or right based on index
                opacity: 0
            }, {
                x: 0, // Animate to their normal position
                opacity: 1,
                duration: 1,
                ease: "power3.out"
            });
        });
    };

    return (
        <Card
            className={'gapless'}
            bordered={false}
            style={{ maxHeight: '800px', overflow: 'auto' }}
            title={<PieGridLegend colorMapping={colorMapping} />}
        >
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {formattedChartData.map((data, index) => (
                    <Tooltip key={index} title={showDelta && data.totalDelta !== null ? `Delta: ${data.totalDelta.toFixed(2)}` : null}>
                        <div
                            ref={el => refs.current[index] = el}
                            style={{ height: '80px', width: `calc(100% / ${rows} - 15px)`, margin: '30px 10px' }}
                        >
                            <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '11px', fontWeight: '600' }}>
                                {stripDayFromData(data.id)}
                                {showDelta && data.totalDelta !== null && data.totalDelta > 0 && (
                                    <span style={{ marginLeft: '5px', color: data.totalDelta >= 0 ? 'green' : 'red' }}>
                                        ({data.totalDelta >= 0 ? '+' : ''}{data.totalDelta.toFixed(2)})
                                    </span>
                                )}
                            </div>
                            <NivoPieChart
                                data={formatter(data)}
                                customColors={colorMapping}
                                size="tiny"
                            />
                        </div>
                    </Tooltip>
                ))}
            </div>
        </Card>
    );
};

const PieGridLegend = ({ colorMapping }) => (
    <Row justify={'start'}>
        {Object.keys(colorMapping).map((key, index) => (
            <ColoredTag key={index} name={key} color={colorMapping[key]} />
        ))}
    </Row>
);

export default PieGrid;
